module.exports = __webpack_public_path__ + "static/img/banner7.cc735cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner7.png
// module id = eY+d
// module chunks = 0